import { Star } from "lucide-react";
import Dialog from "@/components/modals/Dialog";
import "./CountedAttemptHint.css";

/**
 * How `is_primary` is picked. Shown next to Submitted work on Teach.
 */
export function CountedAttemptHintCopy() {
  return (
    <>
      <p>
        The{" "}
        <Star
          className="al-hint-star"
          size={14}
          strokeWidth={1.5}
          fill="currentColor"
          aria-hidden="true"
        />{" "}
        gold star is the try that actually counts — like a favorite, the
        primary submission. It is the one on their path, Progress, and the
        course grade. You do not pick it, and they cannot pin a try.
      </p>
      <p>
        Drafts never count. After they submit, the best score (points earned ÷
        points possible) wins. A tie keeps the newest. Unmarked answers do not
        knock off a try that is already marked. If nothing is marked yet, the
        newest pending try is the one that will count once you finish it.
      </p>
      <p>
        If you change the activity between tries, the better score still wins.
        Each try remembers the version they sat.
      </p>
    </>
  );
}

export default function CountedAttemptHint({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  return (
    <Dialog open={open} title="Which attempt counts" width="26rem" onClose={onClose}>
      <div className="al-hint-copy">
        <CountedAttemptHintCopy />
      </div>
    </Dialog>
  );
}
